import $ from 'jquery';
import inView from 'in-view';

const SELECTOR = '.aos-section';
const vh = $(window).height();
const offset = (vh / 2);

function onDocumentReady() {
	inView.offset(offset);

	$(window).on('resize', onWindowResize);
	inView(SELECTOR).on('enter', onLayoutEnter);
	inView(SELECTOR).on('exit', onLayoutExit);
}

function onWindowResize() {
	const vh = $(window).height();
	const offset = (vh / 2);
	inView.offset(offset);
}

function onLayoutEnter(el) {
	if (el.classList.contains('animate-out')) {
		el.classList.remove('animate-out');
	}

	el.classList.add('animate-in');
}

function onLayoutExit(el) {
	if (el.classList.contains('animate-in')) {
		el.classList.remove('animate-in');
	}

	el.classList.add('animate-out');
}

if (document.getElementById('aos-section-container')) {
	document.addEventListener('DOMContentLoaded', onDocumentReady);
}
